import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/oswebsolutions.webp';
import screenshot_target from '../../../images/letterfunnel/otmannouinou.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Otman Nouinou"
      firstname="Otman"
      companyname="OS Websolutions"
      competition="Xebia en Info Support"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/otmannouinou.js